export default __webpack_public_path__ + "static/media/Descriptivo Conectividad.277266bb.pdf";